<template>

<div class="helper" ref="helper">
  <ButtonHelper
    v-on:click="toggleList"
    :isActive="isListOpen"
  >
    인식 기능 항목
  </ButtonHelper> 
  <template v-if="list && isListOpen">
    <DemoHelperList
      class="list"
      v-on:close="toggleList"
      :list="list"
      :title="helperTitle"
      :buttonText="helperButtonText"
    />
  </template>
</div>

</template>

<script>
import ButtonHelper from '@/components/el/ButtonHelper'
import DemoHelperList from '@/components/demos/DemoHelperList'

export default {
  data() {
    return {
      isListOpen: false,
    }
  },
  props: {
    list: Array,
    helperTitle: String,
    helperButtonText: String,
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickOutside)
  },
  methods: {
    toggleList() {
      this.isListOpen = !this.isListOpen
      if (this.isListOpen) {
        document.addEventListener('click', this.clickOutside, false)
      } else {
        document.removeEventListener('click', this.clickOutside)
      }
    },
    clickOutside(e) {
      if (!this.$refs.helper) return

      if (!this.$refs.helper.contains(e.target)) {
        this.isListOpen = false
        document.removeEventListener('click', this.clickOutside)
      }
    }
  },
  components: {
    ButtonHelper,
    DemoHelperList
  }
}
</script>

<style lang="scss" scoped>
.helper {
  position: relative;
  z-index: 30;
  margin: 0 0 12px;
}

.list {
  position: absolute;
  top: 100%;
  left: 0;
}
</style>